import { render, staticRenderFns } from "./praticeHomekemu.vue?vue&type=template&id=654345a4&scoped=true&"
import script from "./praticeHomekemu.vue?vue&type=script&lang=js&"
export * from "./praticeHomekemu.vue?vue&type=script&lang=js&"
import style0 from "./praticeHomekemu.vue?vue&type=style&index=0&id=654345a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654345a4",
  null
  
)

export default component.exports